import { render, staticRenderFns } from "./AtendimentoEmBloco.vue?vue&type=template&id=12883500&"
import script from "./AtendimentoEmBloco.vue?vue&type=script&lang=js&"
export * from "./AtendimentoEmBloco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports